export enum DatasetRefreshStatusType {
        Unknown = "Unknown",   // Unknown if the completion state is unknown or a refresh is in progress.
        Completed = "Completed", // Completed for a successfully completed refresh.
        Failed = "Failed",    // Failed for an unsuccessful refresh (serviceExceptionJson will contain the error code).
        Cancelled = "Cancelled",
        Disabled = "Disabled",   // Disabled if the refresh is disabled by a selective refresh.
        InProgress = "In Progress"
}